var _defs, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2190.54 1967.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 700.67,
    y1: 1298.97,
    x2: 1327.44,
    y2: 1298.97,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 5623.05,
    y1: 940.06,
    x2: 5853.07,
    y2: 940.06,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 2212.82,
    y1: 1684.11,
    x2: 2311.37,
    y2: 1684.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1805.42,
    y1: 1654.61,
    x2: 2071.79,
    y2: 1654.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1533.42,
    y1: 1240.51,
    x2: 1981.48,
    y2: 1240.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1840.26,
    y1: 1916.32,
    x2: 1871.33,
    y2: 1916.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1613.11,
    y1: 1584.21,
    x2: 1665.25,
    y2: 1584.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 580.29,
    y1: 1326.42,
    x2: 727.36,
    y2: 1326.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#606475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9499a9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2012.52,
    y1: 1382.51,
    x2: 2236.6,
    y2: 1382.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2c4c6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 540.69,
    y1: 1037.31,
    x2: 1182.98,
    y2: 1037.31,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1306.06,
    y1: 978.62,
    x2: 1658.97,
    y2: 978.62,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1221.28,
    y1: 686.22,
    x2: 1548.81,
    y2: 686.22,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1107.41,
    y1: 1233.29,
    x2: 905.18,
    y2: 958.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d0d5e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a4a9b8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 701.34,
    y1: 1203.51,
    x2: 1201.84,
    y2: 1203.51,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 707.49,
    y1: 1149.07,
    x2: 1201.88,
    y2: 1149.07,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 5380.48,
    y1: 828.18,
    x2: 5595.71,
    y2: 828.18,
    gradientTransform: "translate(-3462.03)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c6fbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ca3d8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 2065.42,
    y1: 884.65,
    x2: 2368.79,
    y2: 884.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffac06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa8a13"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-293.73 -428.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1816.33 990.62-168 97.75a85.23 85.23 0 0 1 18.49-8l168-97.76a84.77 84.77 0 0 0-18.49 8.01Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-293.73 -428.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2186.64 1881.69 168-97.76a204.49 204.49 0 0 0 23.84-52.1l-168 97.76a204.65 204.65 0 0 1-23.84 52.1Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(-293.73 -428.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1790.58 973.76 85.65-49.84a44.62 44.62 0 0 0 7.67-5.68l-85.65 49.85a43.8 43.8 0 0 1-7.67 5.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(-293.73 -428.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1594.28 436.33-85.65 49.84a43 43 0 0 1 9.43-4.07l85.65-49.85a43.29 43.29 0 0 0-9.43 4.08Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(-293.73 -428.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1783.08 890.64 85.65-49.84a104.4 104.4 0 0 0 12.15-26.56l-85.65 49.84a104.06 104.06 0 0 1-12.15 26.56Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-293.73 -428.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2201.35 2044.71 168-97.76a85.45 85.45 0 0 0 15-11.12l-168 97.76a86 86 0 0 1-15 11.12Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8",
    transform: "translate(-293.73 -428.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1239.65 1360.92-106 61.69a53.87 53.87 0 0 1 11.67-5l106-61.69a53.45 53.45 0 0 0-11.67 5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(-293.73 -428.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1473.33 1923.24 106-61.69a129.37 129.37 0 0 0 15-32.88l-106 61.69a129 129 0 0 1-15 32.88Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(-293.73 -428.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m1482.62 2026.11 106-61.69a53.64 53.64 0 0 0 9.49-7l-106 61.69a54.38 54.38 0 0 1-9.49 7Z"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill:#2b2e3d}.cls-3{opacity:0}.cls-4{opacity:.04}.cls-5{opacity:.07}.cls-6{opacity:.11}.cls-7{opacity:.15}.cls-8{opacity:.19}.cls-9{opacity:.22}.cls-10{opacity:.26}.cls-11{opacity:.3}.cls-12{opacity:.33}.cls-13{opacity:.37}.cls-14{opacity:.41}.cls-15{opacity:.44}.cls-16{opacity:.48}.cls-17{opacity:.52}.cls-18{opacity:.56}.cls-19{opacity:.59}.cls-20{opacity:.63}.cls-21{opacity:.67}.cls-22{opacity:.7}.cls-23{opacity:.74}.cls-24{opacity:.78}.cls-25{opacity:.81}.cls-26{opacity:.85}.cls-27{opacity:.89}.cls-28{opacity:.93}.cls-29{opacity:.96}.cls-31{opacity:.1}.cls-32{fill:#686b71}.cls-33{fill:#e0e0e0}.cls-34{fill:#6c6f76}.cls-35{isolation:isolate}.cls-38{fill:#898d95}.cls-39{fill:#858891}.cls-40{fill:#81848c}.cls-41{fill:#8e919a}.cls-43{fill:#9699a3}.cls-44{fill:#7d8088}.cls-45{fill:#a6aab5}.cls-46{fill:#767880}.cls-47{fill:#7f828a}.cls-48{fill:#9ea1ab}.cls-49{fill:#c2c4c6}.cls-70{fill:#2d2f4f}.cls-74{fill:#c6c6c6}.cls-79{fill:#ffbdbd}"))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.16
    }
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1707.95,
    cy: 1686.15,
    rx: 426.69,
    ry: 198.48
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1707.95,
    cy: 1686.15,
    rx: 419.75,
    ry: 195.25
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1707.95,
    cy: 1686.15,
    rx: 412.81,
    ry: 192.02
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1707.95,
    cy: 1686.15,
    rx: 405.87,
    ry: 188.79
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 1707.95,
    cy: 1686.15,
    rx: 398.92,
    ry: 185.56
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1707.95,
    cy: 1686.15,
    rx: 391.98,
    ry: 182.34
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 1707.95,
    cy: 1686.15,
    rx: 385.04,
    ry: 179.11
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 1707.95,
    cy: 1686.15,
    rx: 378.1,
    ry: 175.88
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 1707.95,
    cy: 1686.15,
    rx: 371.16,
    ry: 172.65
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 1707.95,
    cy: 1686.15,
    rx: 364.22,
    ry: 169.42
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 1707.95,
    cy: 1686.15,
    rx: 357.28,
    ry: 166.19
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 1707.95,
    cy: 1686.15,
    rx: 350.34,
    ry: 162.96
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 1707.95,
    cy: 1686.15,
    rx: 343.39,
    ry: 159.73
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 1707.95,
    cy: 1686.15,
    rx: 336.45,
    ry: 156.51
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 1707.95,
    cy: 1686.15,
    rx: 329.51,
    ry: 153.28
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 1707.95,
    cy: 1686.15,
    rx: 322.57,
    ry: 150.05
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 1707.95,
    cy: 1686.15,
    rx: 315.63,
    ry: 146.82
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 1707.95,
    cy: 1686.15,
    rx: 308.69,
    ry: 143.59
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 1707.95,
    cy: 1686.15,
    rx: 301.75,
    ry: 140.36
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 1707.95,
    cy: 1686.15,
    rx: 294.81,
    ry: 137.13
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 1707.95,
    cy: 1686.15,
    rx: 287.86,
    ry: 133.9
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 1707.95,
    cy: 1686.15,
    rx: 280.92,
    ry: 130.67
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 1707.95,
    cy: 1686.15,
    rx: 273.98,
    ry: 127.45
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 1707.95,
    cy: 1686.15,
    rx: 267.04,
    ry: 124.22
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 1707.95,
    cy: 1686.15,
    rx: 260.1,
    ry: 120.99
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 1707.95,
    cy: 1686.15,
    rx: 253.16,
    ry: 117.76
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 1707.95,
    cy: 1686.15,
    rx: 246.22,
    ry: 114.53
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1707.95,
    cy: 1766.07,
    rx: 426.69,
    ry: 198.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1707.95,
    cy: 1766.07,
    rx: 419.75,
    ry: 195.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1707.95,
    cy: 1766.07,
    rx: 412.81,
    ry: 192.02
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1707.95,
    cy: 1766.07,
    rx: 405.87,
    ry: 188.79
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 1707.95,
    cy: 1766.07,
    rx: 398.92,
    ry: 185.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1707.95,
    cy: 1766.07,
    rx: 391.98,
    ry: 182.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 1707.95,
    cy: 1766.07,
    rx: 385.04,
    ry: 179.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 1707.95,
    cy: 1766.07,
    rx: 378.1,
    ry: 175.88
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 1707.95,
    cy: 1766.07,
    rx: 371.16,
    ry: 172.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 1707.95,
    cy: 1766.07,
    rx: 364.22,
    ry: 169.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 1707.95,
    cy: 1766.07,
    rx: 357.28,
    ry: 166.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 1707.95,
    cy: 1766.07,
    rx: 350.34,
    ry: 162.96
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 1707.95,
    cy: 1766.07,
    rx: 343.39,
    ry: 159.73
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 1707.95,
    cy: 1766.07,
    rx: 336.45,
    ry: 156.51
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 1707.95,
    cy: 1766.07,
    rx: 329.51,
    ry: 153.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 1707.95,
    cy: 1766.07,
    rx: 322.57,
    ry: 150.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 1707.95,
    cy: 1766.07,
    rx: 315.63,
    ry: 146.82
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 1707.95,
    cy: 1766.07,
    rx: 308.69,
    ry: 143.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 1707.95,
    cy: 1766.07,
    rx: 301.75,
    ry: 140.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 1707.95,
    cy: 1766.07,
    rx: 294.81,
    ry: 137.13
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 1707.95,
    cy: 1766.07,
    rx: 287.86,
    ry: 133.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 1707.95,
    cy: 1766.07,
    rx: 280.92,
    ry: 130.67
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 1707.95,
    cy: 1766.07,
    rx: 273.98,
    ry: 127.45
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 1707.95,
    cy: 1766.07,
    rx: 267.04,
    ry: 124.22
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 1707.95,
    cy: 1766.07,
    rx: 260.1,
    ry: 120.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 1707.95,
    cy: 1766.07,
    rx: 253.16,
    ry: 117.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 1707.95,
    cy: 1766.07,
    rx: 246.22,
    ry: 114.53
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1014.4,
    cy: 1766.07,
    rx: 426.69,
    ry: 198.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1014.4,
    cy: 1766.07,
    rx: 419.75,
    ry: 195.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1014.4,
    cy: 1766.07,
    rx: 412.81,
    ry: 192.02
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 1014.4,
    cy: 1766.07,
    rx: 405.87,
    ry: 188.79
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 1014.4,
    cy: 1766.07,
    rx: 398.92,
    ry: 185.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 1014.4,
    cy: 1766.07,
    rx: 391.98,
    ry: 182.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 1014.4,
    cy: 1766.07,
    rx: 385.04,
    ry: 179.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 1014.4,
    cy: 1766.07,
    rx: 378.1,
    ry: 175.88
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 1014.4,
    cy: 1766.07,
    rx: 371.16,
    ry: 172.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 1014.4,
    cy: 1766.07,
    rx: 364.22,
    ry: 169.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 1014.4,
    cy: 1766.07,
    rx: 357.28,
    ry: 166.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 1014.4,
    cy: 1766.07,
    rx: 350.34,
    ry: 162.96
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 1014.4,
    cy: 1766.07,
    rx: 343.39,
    ry: 159.73
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 1014.4,
    cy: 1766.07,
    rx: 336.45,
    ry: 156.51
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 1014.4,
    cy: 1766.07,
    rx: 329.51,
    ry: 153.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 1014.4,
    cy: 1766.07,
    rx: 322.57,
    ry: 150.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 1014.4,
    cy: 1766.07,
    rx: 315.63,
    ry: 146.82
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 1014.4,
    cy: 1766.07,
    rx: 308.69,
    ry: 143.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 1014.4,
    cy: 1766.07,
    rx: 301.75,
    ry: 140.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 1014.4,
    cy: 1766.07,
    rx: 294.81,
    ry: 137.13
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 1014.4,
    cy: 1766.07,
    rx: 287.86,
    ry: 133.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 1014.4,
    cy: 1766.07,
    rx: 280.92,
    ry: 130.67
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 1014.4,
    cy: 1766.07,
    rx: 273.98,
    ry: 127.45
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 1014.4,
    cy: 1766.07,
    rx: 267.04,
    ry: 124.22
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 1014.4,
    cy: 1766.07,
    rx: 260.1,
    ry: 120.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 1014.4,
    cy: 1766.07,
    rx: 253.16,
    ry: 117.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 1014.4,
    cy: 1766.07,
    rx: 246.22,
    ry: 114.53
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 433.63,
    cy: 1226.67,
    rx: 426.69,
    ry: 198.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 433.63,
    cy: 1226.67,
    rx: 419.75,
    ry: 195.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 433.63,
    cy: 1226.67,
    rx: 412.81,
    ry: 192.02
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 433.63,
    cy: 1226.67,
    rx: 405.87,
    ry: 188.79
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 433.63,
    cy: 1226.67,
    rx: 398.92,
    ry: 185.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 433.63,
    cy: 1226.67,
    rx: 391.98,
    ry: 182.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 433.63,
    cy: 1226.67,
    rx: 385.04,
    ry: 179.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 433.63,
    cy: 1226.67,
    rx: 378.1,
    ry: 175.88
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 433.63,
    cy: 1226.67,
    rx: 371.16,
    ry: 172.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 433.63,
    cy: 1226.67,
    rx: 364.22,
    ry: 169.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 433.63,
    cy: 1226.67,
    rx: 357.28,
    ry: 166.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 433.63,
    cy: 1226.67,
    rx: 350.34,
    ry: 162.96
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 433.63,
    cy: 1226.67,
    rx: 343.39,
    ry: 159.73
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 433.63,
    cy: 1226.67,
    rx: 336.45,
    ry: 156.51
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 433.63,
    cy: 1226.67,
    rx: 329.51,
    ry: 153.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 433.63,
    cy: 1226.67,
    rx: 322.57,
    ry: 150.05
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 433.63,
    cy: 1226.67,
    rx: 315.63,
    ry: 146.82
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 433.63,
    cy: 1226.67,
    rx: 308.69,
    ry: 143.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 433.63,
    cy: 1226.67,
    rx: 301.75,
    ry: 140.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 433.63,
    cy: 1226.67,
    rx: 294.81,
    ry: 137.13
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 433.63,
    cy: 1226.67,
    rx: 287.86,
    ry: 133.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 433.63,
    cy: 1226.67,
    rx: 280.92,
    ry: 130.67
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 433.63,
    cy: 1226.67,
    rx: 273.98,
    ry: 127.45
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 433.63,
    cy: 1226.67,
    rx: 267.04,
    ry: 124.22
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 433.63,
    cy: 1226.67,
    rx: 260.1,
    ry: 120.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 433.63,
    cy: 1226.67,
    rx: 253.16,
    ry: 117.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 433.63,
    cy: 1226.67,
    rx: 246.22,
    ry: 114.53
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m1683.83 1613.2 167.98-97.75 31.31-97.06-167.99 97.75-31.3 97.06z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m1345.47 874.96 167.98-97.76-100.01-22.08-167.98 97.76 100.01 22.08z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1784.12 1520.11c-.32-1.94-.6-3.87-.88-5.8-.12-.91-.29-1.83-.41-2.74 0-.24 0-.48-.07-.71q-.78-6.22-1.21-12.36c-.06-.87-.11-1.74-.16-2.61-.25-4.2-.41-8.38-.4-12.51.13-45.43 16.14-77.39 42-92.41l168-97.76c-25.82 15-41.83 47-42 92.41 0 4.13.16 8.31.4 12.51.05.87.1 1.74.16 2.61q.43 6.13 1.21 12.36c.15 1.15.32 2.3.49 3.45.27 1.93.55 3.87.87 5.81.22 1.3.46 2.61.69 3.91q.51 2.82 1.09 5.65.45 2.25 1 4.5c.28 1.26.56 2.52.86 3.78q.6 2.47 1.23 4.93c.32 1.25.64 2.5 1 3.75.27 1 .56 2 .84 3 1.18 4.15 2.43 8.29 3.79 12.43.11.31.2.63.3.94 1.34 4 2.79 8 4.3 12 .38 1 .77 2 1.16 3q2 5.07 4.12 10.1c.22.52.42 1 .65 1.54 1.61 3.71 3.31 7.4 5.06 11.07.46 1 .94 1.93 1.41 2.89q2.13 4.37 4.38 8.67c.46.88.92 1.77 1.39 2.65q2.88 5.4 6 10.71c.39.67.8 1.34 1.19 2q2.71 4.61 5.57 9.12l1.68 2.66c2.37 3.67 4.78 7.31 7.28 10.88l1.16 1.62q3.9 5.53 8 10.87l1.07 1.41q5.15 6.63 10.59 12.91c.47.55.94 1.11 1.42 1.66 2.23 2.55 4.48 5.06 6.78 7.52.12.12.23.26.35.39 2.41 2.57 4.86 5.07 7.34 7.53 1.57 1.56 3.16 3.09 4.76 4.61l1.32 1.27q3.15 2.94 6.35 5.75c.58.51 1.17 1 1.76 1.5 1.57 1.36 3.14 2.69 4.73 4 .79.65 1.59 1.28 2.38 1.92 1.42 1.12 2.83 2.24 4.25 3.33l2.58 1.93c1.41 1 2.82 2.07 4.24 3.08l2.55 1.79c1.54 1.06 3.09 2.08 4.64 3.09.74.48 1.46 1 2.2 1.44 2.29 1.44 4.59 2.85 6.91 4.19 3.06 1.77 6.09 3.38 9.11 4.9.87.44 1.73.86 2.6 1.28 2.3 1.11 4.58 2.16 6.85 3.13.8.34 1.61.71 2.41 1 2.14.87 4.26 1.67 6.37 2.42.51.19 1 .41 1.56.58 2.61.9 5.2 1.69 7.76 2.4 1.5.41 3 .77 4.48 1.11.69.17 1.4.36 2.09.51q3.29.72 6.51 1.21h.28c2 .29 3.87.52 5.78.7.65.06 1.28.09 1.93.14 1.18.09 2.35.15 3.51.19 2.83.1 5.61.09 8.34-.07.47 0 .93-.09 1.4-.12q3.32-.25 6.51-.77c.66-.1 1.33-.2 2-.32 2.45-.46 4.86-1 7.19-1.66l.31-.1c2.22-.66 4.37-1.44 6.49-2.3.62-.25 1.23-.51 1.84-.78 1.8-.79 3.58-1.66 5.3-2.6.57-.31 1.16-.58 1.72-.91l-168 97.76-.78.45c-.31.17-.64.3-.94.46-1.73.94-3.49 1.8-5.3 2.59-.34.15-.65.35-1 .49s-.57.19-.85.3a68.3 68.3 0 0 1-6.49 2.29 2.67 2.67 0 0 1-.26.09c-2.33.67-4.74 1.2-7.18 1.65-.29.06-.56.15-.84.2s-.78.07-1.16.13c-2.13.34-4.3.6-6.5.76-.35 0-.68.1-1 .13h-.53c-2.73.16-5.51.17-8.34.07h-.81c-.89 0-1.8-.13-2.7-.19-.65 0-1.28-.08-1.93-.14q-2.87-.27-5.78-.7h-.28c-2.15-.33-4.31-.74-6.48-1.21-.71-.15-1.42-.35-2.13-.52-1.35-.31-2.69-.61-4.06-1l-.39-.12c-2.56-.71-5.15-1.5-7.76-2.4-.52-.18-1.06-.4-1.58-.58-2.1-.75-4.22-1.55-6.35-2.43-.29-.11-.56-.2-.84-.32-.52-.21-1-.49-1.57-.71-2.27-1-4.55-2-6.86-3.14-.86-.42-1.72-.83-2.59-1.27-3-1.53-6-3.13-9.12-4.9a214.57 214.57 0 0 1-6.89-4.19c-.75-.47-1.49-1-2.23-1.46q-2.31-1.5-4.61-3.07c-.86-.59-1.71-1.19-2.56-1.8q-2.13-1.5-4.24-3.07l-2.59-1.94c-1.41-1.08-2.82-2.19-4.22-3.31-.8-.65-1.61-1.28-2.41-1.94-1.6-1.31-3.18-2.66-4.75-4l-1.72-1.47q-3.21-2.82-6.35-5.76l-1.37-1.31c-1.38-1.3-2.76-2.61-4.12-4-.2-.2-.39-.42-.6-.62q-3.72-3.69-7.34-7.54c-.1-.1-.19-.21-.28-.31-2.32-2.48-4.6-5-6.85-7.59l-.64-.71c-.27-.31-.52-.64-.78-1q-5.43-6.3-10.59-12.92c-.1-.12-.21-.24-.3-.36-.26-.34-.5-.7-.77-1q-4.1-5.34-8-10.88c-.26-.37-.54-.72-.8-1.09l-.35-.52c-2.49-3.57-4.91-7.21-7.28-10.88-.23-.36-.47-.69-.7-1.05-.34-.53-.64-1.07-1-1.61q-2.85-4.51-5.56-9.12c-.29-.49-.61-1-.89-1.45l-.32-.57q-3.06-5.29-6-10.7c-.16-.29-.33-.57-.48-.87-.32-.59-.6-1.2-.91-1.79q-2.26-4.32-4.39-8.67c-.29-.6-.62-1.19-.9-1.79-.18-.36-.33-.73-.5-1.08-1.75-3.68-3.45-7.36-5.06-11.08 0-.11-.11-.23-.16-.35-.17-.4-.32-.8-.49-1.21-1.44-3.34-2.8-6.7-4.12-10.07-.21-.55-.46-1.09-.67-1.64s-.32-.92-.49-1.38c-1.51-4-3-8-4.3-12 0-.08-.06-.16-.08-.23-.08-.24-.14-.47-.22-.71-1.36-4.14-2.61-8.28-3.78-12.42-.15-.52-.33-1-.48-1.55s-.24-1-.38-1.46c-.33-1.24-.65-2.47-1-3.71q-.64-2.48-1.24-5c-.3-1.26-.58-2.52-.86-3.78-.2-.88-.42-1.76-.6-2.64-.14-.62-.23-1.25-.36-1.87-.39-1.88-.74-3.75-1.09-5.63-.18-1.13-.42-2.44-.64-3.75Z",
    transform: "translate(-293.73 -428.5)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35",
    style: {
      clipPath: "url(#clip-path)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m2201.35 2044.71 168-97.76a85.45 85.45 0 0 0 15-11.12l-168 97.76a86 86 0 0 1-15 11.12",
    transform: "translate(-293.73 -428.5)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35",
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m1666.84 1080.39 168-97.76a87.4 87.4 0 0 0-8.67 3.1l-168 97.76a84.93 84.93 0 0 1 8.67-3.1",
    transform: "translate(-293.73 -428.5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m1658.17 1083.49 168-97.76a84.26 84.26 0 0 0-8.85 4.33l-168 97.76a82.34 82.34 0 0 1 8.85-4.33",
    transform: "translate(-293.73 -428.5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m1649.32 1087.82 168-97.76-1 .56-168 97.75 1-.55",
    transform: "translate(-293.73 -428.5)"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m1922.66 1605.08 167.98-97.75 18.68-17.23-167.98 97.76-18.68 17.22z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m1397.46 644.53 167.98-97.76-24.34 7.36-167.99 97.76 24.35-7.36z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m1941.34 1587.86 167.98-97.76-48.43-134.67-167.98 97.76 48.43 134.67zM1489.88 754.12l167.98-97.75-92.42-109.6-167.98 97.76 92.42 109.59z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35",
    style: {
      clipPath: "url(#clip-path-3)"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m2186.64 1881.69 168-97.76a204.49 204.49 0 0 0 23.84-52.1l-168 97.76a204.65 204.65 0 0 1-23.84 52.1",
    transform: "translate(-293.73 -428.5)"
  })))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1824.77 1185.23c-4.21-.69-8.39-1.26-12.51-1.7l-.92-.11c-4.4-.44-8.74-.7-13-.85h-2.35c-4.16-.09-8.29-.08-12.34.11l168-97.76c4.05-.19 8.18-.19 12.34-.11l2.35.06h1.93c3.66.16 7.37.43 11.11.8.31 0 .62.09.92.12 3.35.35 6.71.75 10.12 1.28.79.12 1.6.28 2.39.41s1.85.32 2.78.48c4.38.78 8.79 1.64 13.26 2.7l-168 97.76c-4.47-1.06-8.88-1.92-13.26-2.7-.97-.17-1.89-.34-2.82-.49Z",
    transform: "translate(-293.73 -428.5)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M2205.31 1610.82q-1.74-6.54-3.63-13.09c-.53-1.85-1.06-3.7-1.62-5.55q-2.45-8.16-5.12-16.31c-.18-.55-.34-1.1-.52-1.64q-3.26-9.8-6.85-19.56l168-97.76q3.54 9.6 6.75 19.24c0 .11.07.22.1.33.18.53.33 1 .51 1.58q2.68 8.18 5.14 16.38c.55 1.84 1.07 3.67 1.6 5.51.62 2.14 1.28 4.28 1.88 6.42s1.17 4.48 1.77 6.72c.47 1.78.95 3.55 1.41 5.33 1.52 6 3 11.94 4.3 17.9l-168 97.75c-1.32-6-2.78-11.91-4.3-17.88a531.9 531.9 0 0 0-1.42-5.37Z",
    transform: "translate(-293.73 -428.5)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M2046.69 1322.85c-1.78-1.93-3.53-3.91-5.33-5.82-4.22-4.49-8.52-8.88-12.84-13.22-.9-.9-1.78-1.84-2.69-2.74q-7.45-7.38-15.1-14.42l168-97.76q7.64 7 15.1 14.42l.27.26c.82.8 1.6 1.67 2.41 2.48 4.33 4.34 8.63 8.73 12.86 13.23 1.78 1.9 3.53 3.87 5.3 5.8 3.29 3.59 6.58 7.2 9.81 10.89.65.74 1.33 1.45 2 2.19q4.71 5.44 9.34 11l-168 97.76c-3.73-4.49-7.53-8.87-11.34-13.22-3.23-3.7-6.48-7.26-9.79-10.85Z",
    transform: "translate(-293.73 -428.5)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m2017.12 1299.02 167.98-97.75-99.82-93.46-167.98 97.76 99.82 93.45z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M2314.64 1819.13a234.84 234.84 0 0 0 .15-54.38l-3.95-37.22 168-97.76 3.94 37.22a234.93 234.93 0 0 1-.15 54.39l-4.15 32.57-168 97.76Z",
    transform: "translate(-293.73 -428.5)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m2040.13 993.61 30.33 12.9a215.75 215.75 0 0 1 23.64 11.86 259.27 259.27 0 0 1 23.62 15.47l30.33 22.16-168 97.76-30.33-22.17a261.25 261.25 0 0 0-23.62-15.46 214 214 0 0 0-23.64-11.86l-30.33-12.9Z",
    transform: "translate(-293.73 -428.5)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m1717 858.14 167.98-97.75-30.66-132.89-167.98 97.76L1717 858.14z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m1893.84 1126.16 167.98-97.75 49.03-78.36-167.98 97.75-49.03 78.36z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m1866.79 915.88 167.98-97.76-92.71 2.56-167.98 97.75 92.71-2.55z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M2206.64 1415.53c-1.53-2.78-3-5.58-4.63-8.33-1.19-2-2.45-4.06-3.67-6.09-1.72-2.86-3.43-5.73-5.21-8.55-2.72-4.29-5.49-8.55-8.36-12.72l-24.26-35.46 168-97.76 24.25 35.46q3.91 5.7 7.64 11.55c.25.38.47.78.72 1.17 1.78 2.82 3.49 5.69 5.21 8.55 1 1.75 2.16 3.46 3.18 5.22.17.29.32.58.49.87 1.59 2.75 3.1 5.55 4.63 8.33 1.07 1.93 2.19 3.84 3.22 5.79l.35.69c1.53 2.88 3 5.81 4.42 8.72 1 2 2 3.88 2.95 5.84l.5 1 18.52 38.7-168 97.76-18.51-38.7c-1.11-2.31-2.31-4.58-3.45-6.88-1.46-2.91-2.89-5.84-4.42-8.72-1.15-2.14-2.38-4.28-3.57-6.44Z",
    transform: "translate(-293.73 -428.5)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m1539.18 1281.38 100 22.08c6-19.57 14-37 23.86-52l-48.42-134.7 18.68-17.2a84.44 84.44 0 0 1 33.52-19.13l24.35-7.36 92.42 109.6a206.65 206.65 0 0 1 57.2 5.78l31.34-97 30.33 12.9a214 214 0 0 1 23.64 11.86 261.25 261.25 0 0 1 23.62 15.46l30.33 22.17 30.66 132.89a621.49 621.49 0 0 1 57.08 60.29l92.7-2.56 24.26 35.46a432.37 432.37 0 0 1 33.31 57.77l18.52 38.7-49 78.36a616.37 616.37 0 0 1 23.46 79.4l99.81 93.46 3.95 37.22a234.84 234.84 0 0 1-.15 54.38l-4.15 32.58-100-22.12a204.65 204.65 0 0 1-23.84 52.1l48.43 134.67-18.68 17.23a85.45 85.45 0 0 1-33.52 19.13l-24.38 7.34-92.39-109.58a207.09 207.09 0 0 1-57.24-5.83l-31.3 97.06-30.36-12.89a215.4 215.4 0 0 1-23.63-11.84 264.51 264.51 0 0 1-23.63-15.48l-30.3-22.19-30.66-132.98a620.55 620.55 0 0 1-57-60.24l-92.74 2.54-24.22-35.44a431.79 431.79 0 0 1-33.31-57.77l-18.52-38.73 49-78.33a613.56 613.56 0 0 1-23.49-79.46l-99.82-93.42-3.92-37.23a235.49 235.49 0 0 1 .16-54.39Zm385.21 450.72c79.43 45.92 144 9 144.3-82.39s-63.94-202.77-143.37-248.7-144.07-9.07-144.33 82.37 63.93 202.77 143.4 248.72",
    transform: "translate(-293.73 -428.5)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2013.83 1294a621.36 621.36 0 0 1 57.08 60.29l92.71-2.56 24.26 35.46a434.21 434.21 0 0 1 33.31 57.78l15.17 31.71.24-.37-18.52-38.7a432.37 432.37 0 0 0-33.31-57.77l-24.26-35.46-92.7 2.56a623.35 623.35 0 0 0-55.29-58.61Z",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2214.14 1641.43 97.23 91-.53-4.94-98-91.78c.42 1.93.88 3.83 1.3 5.72Z",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1927.49 1739.45c79.43 45.93 144 9 144.3-82.38.1-34.38-8.92-71.57-24.42-107 13.59 33.23 21.41 67.67 21.32 99.68-.26 91.41-64.87 128.31-144.3 82.39-49.59-28.67-93.23-82.82-119-141.7 25.27 61.65 70.46 119.15 122.1 149.01Z",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1538 1375.68a234.87 234.87 0 0 1 .15-54.38l4.12-32.56 100 22.08c6-19.58 14-37 23.86-52l-48.42-134.71 18.67-17.19a84.55 84.55 0 0 1 33.53-19.13l24.35-7.36 92.46 109.57a206.67 206.67 0 0 1 57.2 5.79l31.34-97 30.32 12.91a214.88 214.88 0 0 1 23.65 11.85 262.81 262.81 0 0 1 23.62 15.47l28.63 20.93-1.41-6.12-30.33-22.17a261.25 261.25 0 0 0-23.62-15.46 214 214 0 0 0-23.64-11.86l-30.33-12.9-31.34 97a206.65 206.65 0 0 0-57.2-5.78L1691.19 1073l-24.35 7.36a84.44 84.44 0 0 0-33.52 19.13l-18.68 17.2 48.43 134.7c-9.86 15-17.87 32.47-23.87 52l-100-22.08-4.11 32.56a235.49 235.49 0 0 0-.16 54.39l3.92 37.23 2.59 2.43Z",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1842.06 1853.77c-.61-.56-1.2-1.13-1.8-1.69l29.38 127.23 1.69 1.24Z",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1616.45 1663.75 48.8-78a612.51 612.51 0 0 1-23.5-79.46l-1.79-1.68a616 616 0 0 0 22.18 73.78l-49 78.33Z",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m1382.75 543.72 85.65-49.84 15.96-49.49-85.65 49.85-15.96 49.48z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m1210.24 167.33 85.64-49.84-50.99-11.26-85.64 49.84 50.99 11.26z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1577.85 706.29c-.16-1-.3-2-.44-3-.07-.46-.15-.93-.21-1.4v-.36c-.26-2.11-.47-4.21-.61-6.3 0-.44-.06-.89-.09-1.33-.12-2.14-.21-4.27-.2-6.38.07-23.16 8.23-39.45 21.39-47.12l85.65-49.84c-13.17 7.66-21.33 24-21.39 47.12 0 2.1.07 4.24.2 6.38 0 .44.05.88.08 1.33.15 2.09.35 4.19.62 6.3.07.58.16 1.17.24 1.76.14 1 .29 2 .45 3 .11.66.23 1.33.35 2 .18.95.36 1.91.56 2.88.15.76.32 1.52.49 2.29s.28 1.28.44 1.93c.2.84.41 1.67.62 2.51l.5 1.91c.14.51.29 1 .43 1.52.6 2.12 1.24 4.23 1.94 6.34.05.16.09.32.15.48.68 2 1.42 4.08 2.19 6.12.19.51.39 1 .59 1.53q1 2.58 2.1 5.15l.33.78c.82 1.89 1.69 3.77 2.58 5.64l.72 1.48q1.08 2.22 2.24 4.42c.23.45.46.9.7 1.35 1 1.83 2 3.66 3 5.46l.61 1q1.38 2.36 2.84 4.66l.85 1.35c1.21 1.87 2.44 3.73 3.71 5.55l.6.82q2 2.82 4.08 5.55l.54.71c1.75 2.26 3.56 4.45 5.4 6.59l.72.84q1.71 1.95 3.46 3.84l.18.2c1.23 1.31 2.48 2.58 3.74 3.84.8.79 1.61 1.57 2.43 2.35l.67.64q1.6 1.5 3.24 2.94l.9.76c.8.69 1.6 1.37 2.41 2l1.21 1c.72.57 1.44 1.14 2.17 1.69.44.34.87.67 1.31 1 .72.54 1.44 1.06 2.17 1.57l1.3.91c.78.54 1.57 1.06 2.36 1.58l1.12.73a92.108 92.108 0 0 0 8.17 4.64l1.33.65c1.17.57 2.33 1.1 3.49 1.6.41.17.82.36 1.23.52 1.09.45 2.17.86 3.24 1.24l.8.3a63.436 63.436 0 0 0 6.28 1.79l1.07.26c1.12.24 2.22.45 3.32.61h.14c1 .15 2 .27 3 .36l1 .07c.6 0 1.2.08 1.79.1 1.44.05 2.86 0 4.25 0l.72-.06c1.12-.09 2.23-.22 3.32-.39.33 0 .67-.1 1-.17 1.24-.23 2.47-.5 3.66-.84h.16c1.13-.34 2.23-.74 3.31-1.17l.93-.4c.93-.41 1.83-.85 2.71-1.33.29-.15.59-.29.88-.46l-85.65 49.84-.4.23c-.15.09-.32.15-.48.24q-1.32.72-2.7 1.32c-.17.07-.33.17-.5.25s-.3.09-.44.15c-1.08.43-2.18.83-3.31 1.17h-.13c-1.19.34-2.42.61-3.67.85-.14 0-.28.07-.43.09s-.39 0-.58.07c-1.09.18-2.19.31-3.32.39-.18 0-.35.05-.53.06h-.18c-1.39.09-2.81.09-4.25 0h-.42c-.45 0-.92-.06-1.37-.1l-1-.07c-1-.09-2-.21-3-.36h-.16a51 51 0 0 1-3.29-.61l-1.09-.26c-.69-.17-1.37-.32-2.07-.51l-.2-.06a80.6 80.6 0 0 1-4-1.22c-.27-.09-.54-.2-.81-.3q-1.6-.57-3.24-1.23l-.43-.17c-.26-.11-.53-.25-.8-.36-1.15-.5-2.32-1-3.49-1.6l-1.32-.65c-1.54-.78-3.09-1.6-4.65-2.5-1.18-.68-2.35-1.4-3.52-2.14l-1.13-.74c-.79-.51-1.57-1-2.36-1.56l-1.3-.92q-1.08-.76-2.16-1.56l-1.32-1c-.72-.55-1.44-1.11-2.15-1.69l-1.23-1c-.82-.67-1.62-1.36-2.42-2-.3-.25-.59-.49-.88-.75q-1.64-1.43-3.24-2.93l-.69-.67c-.71-.67-1.41-1.33-2.1-2l-.31-.31c-1.26-1.26-2.52-2.53-3.75-3.85l-.14-.15q-1.77-1.9-3.49-3.87l-.33-.36-.39-.49q-2.78-3.21-5.41-6.59l-.15-.18c-.13-.17-.25-.36-.39-.53q-2.09-2.73-4.08-5.55c-.14-.19-.28-.36-.41-.55l-.18-.27c-1.27-1.82-2.5-3.67-3.71-5.55l-.36-.53-.5-.82q-1.45-2.31-2.83-4.65l-.46-.74a2.69 2.69 0 0 0-.16-.29q-1.56-2.7-3-5.46l-.25-.44c-.16-.3-.3-.61-.46-.91-.77-1.47-1.52-2.94-2.24-4.43-.15-.3-.31-.6-.46-.91s-.17-.37-.25-.55q-1.35-2.8-2.58-5.65l-.09-.17c-.08-.21-.16-.41-.25-.62-.73-1.71-1.42-3.42-2.1-5.14-.1-.28-.23-.55-.34-.83s-.16-.47-.25-.7c-.77-2-1.51-4.08-2.19-6.12v-.12c0-.04-.07-.24-.11-.36-.7-2.11-1.33-4.22-1.93-6.33-.08-.27-.17-.53-.24-.79s-.13-.5-.2-.74c-.17-.64-.33-1.27-.49-1.9q-.33-1.26-.63-2.52c-.15-.64-.3-1.29-.44-1.93-.1-.45-.21-.89-.31-1.34s-.11-.64-.18-1c-.2-1-.38-1.91-.55-2.87-.2-.64-.29-1.27-.44-1.98Z",
    transform: "translate(-293.73 -428.5)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35",
    style: {
      clipPath: "url(#clip-path-4)"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m1790.58 973.76 85.65-49.84a44.62 44.62 0 0 0 7.67-5.68l-85.65 49.85a43.8 43.8 0 0 1-7.67 5.67",
    transform: "translate(-293.73 -428.5)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35",
    style: {
      clipPath: "url(#clip-path-5)"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m1518.06 482.1 85.65-49.85a46.48 46.48 0 0 0-4.43 1.58l-85.64 49.85a41.39 41.39 0 0 1 4.42-1.58",
    transform: "translate(-293.73 -428.5)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m1513.64 483.68 85.64-49.85a43.77 43.77 0 0 0-4.51 2.21l-85.64 49.84a42.72 42.72 0 0 1 4.51-2.2",
    transform: "translate(-293.73 -428.5)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m1509.13 485.88 85.64-49.88-.49.29-85.65 49.84.5-.29",
    transform: "translate(-293.73 -428.5)"
  })))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m1504.52 539.58 85.65-49.84 9.52-8.78-85.65 49.84-9.52 8.78z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1236.75 49.84 1322.39 0l-12.41 3.75-85.65 49.84 12.42-3.75z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m1514.04 530.8 85.65-49.84L1575 412.3l-85.65 49.84 24.69 68.66zM1283.87 105.72l85.64-49.84L1322.39 0l-85.64 49.84 47.12 55.88z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35",
    style: {
      clipPath: "url(#clip-path-6)"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m1783.08 890.64 85.65-49.84a104.4 104.4 0 0 0 12.15-26.56l-85.65 49.84a104.06 104.06 0 0 1-12.15 26.56",
    transform: "translate(-293.73 -428.5)"
  })))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1598.58 535.55c-2.15-.35-4.28-.65-6.38-.86l-.46-.06c-2.25-.23-4.46-.36-6.65-.44h-1.2c-2.13 0-4.23 0-6.29.05l85.64-49.84c2.07-.1 4.17-.1 6.29-.05h2.2c1.87.09 3.76.22 5.67.41.15 0 .31.05.47.06 1.7.18 3.42.39 5.16.65l1.22.22 1.41.24c2.24.4 4.49.84 6.77 1.38l-85.65 49.84c-2.28-.54-4.53-1-6.76-1.37Z",
    transform: "translate(-293.73 -428.5)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1792.6 752.54c-.59-2.23-1.21-4.45-1.85-6.68-.27-.94-.54-1.88-.82-2.83-.84-2.77-1.7-5.54-2.62-8.31-.09-.28-.17-.56-.26-.84q-1.66-5-3.5-10l85.65-49.84q1.8 4.89 3.44 9.8a1.54 1.54 0 0 1 0 .17c.09.27.17.54.26.81q1.38 4.17 2.62 8.35c.28.94.55 1.87.82 2.81.32 1.09.65 2.18 1 3.27s.6 2.29.9 3.43c.24.91.49 1.81.72 2.72.77 3 1.52 6.08 2.19 9.12l-85.64 49.84c-.68-3-1.42-6.07-2.2-9.11-.22-.89-.47-1.8-.71-2.71Z",
    transform: "translate(-293.73 -428.5)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1711.73 605.72c-.91-1-1.8-2-2.72-3q-3.23-3.43-6.55-6.74c-.46-.46-.9-.94-1.37-1.4q-3.79-3.76-7.7-7.35l85.61-49.82q3.9 3.6 7.7 7.36l.13.13c.42.41.82.85 1.23 1.27q3.32 3.32 6.56 6.74c.91 1 1.8 2 2.7 3 1.68 1.84 3.35 3.68 5 5.56.33.38.68.74 1 1.12q2.42 2.78 4.77 5.61l-85.6 49.8c-1.9-2.29-3.83-4.52-5.78-6.74-1.64-1.88-3.31-3.72-4.98-5.54Z",
    transform: "translate(-293.73 -428.5)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m1552.68 383.54 85.64-49.84-50.89-47.65-85.64 49.84 50.89 47.65z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1848.34 858.75a119.84 119.84 0 0 0 .08-27.73l-2-19 85.64-49.84 2 19a119.87 119.87 0 0 1-.07 27.73l-2.12 16.6-85.64 49.85Z",
    transform: "translate(-293.73 -428.5)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m1708.38 437.85 15.46 6.58a110.36 110.36 0 0 1 12.06 6 134.08 134.08 0 0 1 12 7.89l15.47 11.3-85.65 49.84-15.46-11.3a134.6 134.6 0 0 0-12-7.88 110.47 110.47 0 0 0-12.06-6.05l-15.46-6.58Z",
    transform: "translate(-293.73 -428.5)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m1399.66 158.75 85.65-49.84-15.63-67.75L1384.03 91l15.63 67.75z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m1489.83 295.4 85.64-49.84 25-39.95-85.65 49.84-24.99 39.95z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m1476.03 188.19 85.65-49.84-47.27 1.3-85.64 49.84 47.26-1.3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1793.28 653c-.78-1.42-1.55-2.85-2.36-4.25-.61-1-1.25-2.07-1.87-3.11-.88-1.45-1.75-2.92-2.66-4.35-1.39-2.19-2.8-4.36-4.26-6.49l-12.37-18.08 85.65-49.84 12.36 18.08q2 2.91 3.9 5.89l.36.59c.91 1.44 1.78 2.91 2.66 4.37.54.89 1.1 1.76 1.62 2.65.09.15.17.3.25.45.81 1.4 1.58 2.83 2.36 4.24.55 1 1.12 2 1.65 3 .06.11.11.23.17.35.78 1.47 1.51 3 2.25 4.45.5 1 1 2 1.51 3 .09.18.17.36.26.53l9.44 19.73-85.65 49.79-9.44-19.73c-.56-1.18-1.18-2.34-1.76-3.51-.74-1.49-1.47-3-2.25-4.45-.59-1.15-1.21-2.24-1.82-3.31Z",
    transform: "translate(-293.73 -428.5)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m1453 584.57 51 11.26a103.7 103.7 0 0 1 12.16-26.53l-24.68-68.68 9.52-8.77a43 43 0 0 1 17.09-9.75l12.41-3.76 47.13 55.88a105.55 105.55 0 0 1 29.16 2.95l16-49.48 15.46 6.58a110.47 110.47 0 0 1 12.06 6.05 134.6 134.6 0 0 1 12 7.88l15.46 11.3 15.63 67.76a315.32 315.32 0 0 1 29.1 30.74l47.27-1.31 12.37 18.08a220.85 220.85 0 0 1 17 29.46l9.44 19.73-25 39.95a314 314 0 0 1 12 40.48l50.83 47.61 2 19a119.84 119.84 0 0 1-.08 27.73l-2.11 16.61-51-11.28a104.06 104.06 0 0 1-12.15 26.56l24.69 68.66-9.52 8.79a43.55 43.55 0 0 1-17.09 9.75l-12.43 3.74-47.11-55.86a105.76 105.76 0 0 1-29.18-3l-16 49.49-15.43-6.53a111 111 0 0 1-12-6 135.15 135.15 0 0 1-12.06-7.9l-15.44-11.31-15.65-67.76a317.23 317.23 0 0 1-29.09-30.71l-47.28 1.3-12.35-18.07a220.55 220.55 0 0 1-17-29.46l-9.46-19.75 25-39.93a313.74 313.74 0 0 1-12-40.51l-50.9-47.63-2-19a119.3 119.3 0 0 1 .08-27.73Zm196.4 229.8c40.5 23.42 73.44 4.6 73.57-42s-32.59-103.39-73.09-126.8-73.46-4.63-73.59 42 32.59 103.39 73.11 126.81",
    transform: "translate(-293.73 -428.5)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m1047.66 1595.71 106.01-61.68 19.75-61.26-106 61.69-19.76 61.25z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m834.14 1129.84 106-61.69-63.11-13.93-106.01 61.69 63.12 13.93z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1219.32 1695.06c-.2-1.22-.38-2.44-.55-3.66-.08-.58-.19-1.16-.26-1.73v-.45c-.33-2.62-.58-5.21-.76-7.8 0-.55-.07-1.09-.1-1.64-.16-2.65-.26-5.29-.25-7.9.08-28.67 10.18-48.83 26.48-58.32l106-61.69c-16.29 9.49-26.4 29.65-26.48 58.32 0 2.61.1 5.25.25 7.9 0 .55.06 1.09.1 1.64.19 2.58.44 5.18.77 7.8.09.72.2 1.45.3 2.18.18 1.22.35 2.44.55 3.66.14.83.29 1.65.44 2.47.22 1.19.44 2.38.69 3.57.19.94.39 1.89.6 2.84.18.79.36 1.59.55 2.38.25 1 .51 2.08.77 3.12.21.78.41 1.57.62 2.36.17.63.36 1.25.53 1.88.74 2.62 1.53 5.23 2.4 7.85l.18.59q1.28 3.79 2.72 7.57c.24.63.48 1.26.73 1.89.83 2.14 1.69 4.26 2.6 6.38.14.32.27.65.41 1 1 2.34 2.08 4.67 3.19 7 .29.61.59 1.22.89 1.83.9 1.83 1.82 3.66 2.77 5.47.29.56.57 1.12.87 1.67 1.21 2.27 2.47 4.53 3.76 6.76.25.42.51.84.76 1.27q1.71 2.91 3.51 5.76c.35.56.7 1.12 1.06 1.67q2.24 3.48 4.59 6.87l.73 1q2.47 3.49 5 6.86c.23.29.45.6.68.89q3.25 4.18 6.68 8.15l.9 1c1.4 1.61 2.83 3.2 4.27 4.75l.23.25c1.52 1.62 3.07 3.2 4.63 4.75q1.48 1.47 3 2.91l.84.8c1.32 1.24 2.66 2.44 4 3.63l1.11 1c1 .85 2 1.69 3 2.52l1.5 1.21c.89.71 1.79 1.41 2.68 2.1l1.63 1.22c.89.66 1.78 1.31 2.68 1.94l1.61 1.13c1 .67 1.95 1.32 2.93 1.95l1.38.91c1.45.91 2.9 1.8 4.36 2.65 1.93 1.11 3.85 2.13 5.75 3.09.55.28 1.1.54 1.64.8q2.18 1.07 4.32 2l1.52.66c1.36.55 2.69 1 4 1.53.33.11.66.25 1 .36q2.48.86 4.9 1.51c1 .27 1.89.49 2.82.71.44.1.89.23 1.33.32 1.38.3 2.75.55 4.1.76h.18c1.23.18 2.44.32 3.64.44l1.22.09 2.22.12c1.78.06 3.54 0 5.26 0 .3 0 .59 0 .88-.08q2.1-.15 4.11-.48l1.26-.2c1.54-.29 3.06-.62 4.53-1a1.52 1.52 0 0 1 .2-.06c1.4-.42 2.76-.91 4.09-1.45l1.16-.5c1.14-.5 2.26-1 3.35-1.63.36-.2.73-.37 1.08-.58l-106 61.69-.5.29c-.19.11-.4.18-.59.29-1.09.59-2.2 1.13-3.34 1.63-.21.1-.41.22-.63.31l-.53.19c-1.34.54-2.7 1-4.1 1.45h-.16c-1.48.43-3 .76-4.54 1-.18 0-.35.09-.53.12s-.49 0-.73.08c-1.34.22-2.71.38-4.1.48-.22 0-.43.07-.65.08h-.23c-1.72.1-3.48.11-5.26 0h-.52l-1.7-.12-1.22-.09c-1.2-.12-2.42-.26-3.65-.44h-.17c-1.34-.21-2.7-.46-4.08-.76-.44-.09-.89-.22-1.34-.33-.85-.2-1.7-.38-2.56-.62l-.25-.07c-1.61-.45-3.25-1-4.89-1.52-.33-.11-.67-.25-1-.37-1.33-.47-2.66-1-4-1.52l-.53-.21c-.33-.13-.66-.31-1-.45q-2.15-.92-4.32-2c-.55-.26-1.1-.52-1.64-.8-1.91-1-3.82-2-5.75-3.09-1.46-.85-2.91-1.74-4.36-2.65l-1.4-.91c-1-.64-1.95-1.28-2.91-1.94l-1.62-1.14c-.9-.63-1.79-1.28-2.67-1.94l-1.64-1.22-2.66-2.09c-.51-.41-1-.81-1.52-1.23-1-.82-2-1.67-3-2.53-.36-.31-.73-.61-1.09-.93-1.34-1.18-2.68-2.39-4-3.63l-.86-.82c-.88-.83-1.75-1.65-2.6-2.5l-.38-.39c-1.57-1.55-3.12-3.13-4.64-4.76l-.18-.19q-2.19-2.35-4.32-4.79c-.13-.16-.27-.3-.4-.45s-.33-.41-.49-.6q-3.43-4-6.69-8.15l-.19-.23c-.16-.22-.31-.44-.48-.65-1.72-2.25-3.41-4.54-5-6.87-.17-.24-.35-.46-.51-.69s-.15-.22-.22-.33c-1.57-2.25-3.1-4.55-4.59-6.87l-.45-.65c-.21-.34-.4-.69-.61-1-1.2-1.9-2.38-3.82-3.52-5.76-.18-.31-.38-.61-.56-.91l-.19-.36q-1.95-3.35-3.76-6.75c-.1-.19-.21-.37-.31-.55-.2-.38-.37-.76-.57-1.14q-1.43-2.71-2.77-5.47c-.18-.38-.39-.75-.57-1.13-.11-.22-.2-.45-.31-.68-1.11-2.32-2.18-4.64-3.2-7 0-.07-.07-.14-.1-.22-.11-.25-.2-.51-.31-.76q-1.35-3.17-2.6-6.36c-.13-.34-.29-.69-.42-1s-.2-.58-.31-.87c-1-2.52-1.87-5-2.71-7.57a.88.88 0 0 1 0-.15c0-.14-.09-.29-.14-.44-.86-2.61-1.65-5.23-2.39-7.84-.09-.33-.21-.66-.3-1s-.15-.61-.24-.92c-.21-.78-.41-1.56-.61-2.34-.27-1-.53-2.09-.78-3.13l-.54-2.38c-.12-.55-.26-1.11-.38-1.66-.09-.4-.15-.79-.23-1.19-.24-1.18-.47-2.37-.68-3.55-.31-.83-.46-1.65-.6-2.48Z",
    transform: "translate(-293.73 -428.5)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35",
    style: {
      clipPath: "url(#clip-path-7)"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m1482.62 2026.11 106-61.69a53.64 53.64 0 0 0 9.49-7l-106 61.69a54.38 54.38 0 0 1-9.49 7",
    transform: "translate(-293.73 -428.5)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35",
    style: {
      clipPath: "url(#clip-path-8)"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "m1145.31 1417.57 106-61.69a53.15 53.15 0 0 0-5.48 2l-106 61.69a53 53 0 0 1 5.47-2",
    transform: "translate(-293.73 -428.5)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m1139.84 1419.53 106-61.69a51.43 51.43 0 0 0-5.58 2.73l-106 61.69a51.58 51.58 0 0 1 5.59-2.73",
    transform: "translate(-293.73 -428.5)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m1134.25 1422.26 106-61.69-.61.35-106 61.69.61-.35",
    transform: "translate(-293.73 -428.5)"
  })))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m1198.38 1590.59 106-61.69 11.79-10.87-106.01 61.69-11.78 10.87z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m866.95 984.43 106-61.69-15.36 4.64-106.01 61.69 15.37-4.64z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m1210.16 1579.72 106.01-61.69-30.56-84.99-106 61.69 30.55 84.99zM925.27 1053.59l106.01-61.69-58.33-69.16-106 61.69 58.32 69.16z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35",
    style: {
      clipPath: "url(#clip-path-9)"
    }
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m1473.33 1923.24 106-61.69a129.37 129.37 0 0 0 15-32.88l-106 61.69a129 129 0 0 1-15.05 32.88",
    transform: "translate(-293.73 -428.5)"
  })))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M1245 1483.73c-2.66-.43-5.3-.8-7.9-1.07l-.58-.07c-2.78-.28-5.52-.44-8.23-.54h-1.48c-2.63 0-5.23 0-7.79.07l106-61.69c2.56-.12 5.16-.12 7.79-.07h2.7q3.46.15 7 .51l.57.07c2.11.22 4.24.48 6.39.81.5.07 1 .18 1.51.26l1.75.31c2.77.48 5.55 1 8.37 1.7l-106 61.69c-2.82-.67-5.61-1.21-8.38-1.7Z",
    transform: "translate(-293.73 -428.5)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1485.12 1752.31c-.73-2.76-1.5-5.51-2.29-8.27-.34-1.17-.68-2.33-1-3.5q-1.53-5.14-3.23-10.29c-.11-.35-.21-.69-.33-1q-2.06-6.18-4.32-12.34l106-61.69q2.24 6.06 4.26 12.14a1.72 1.72 0 0 1 .07.21c.11.33.21.66.32 1q1.7 5.16 3.24 10.34c.35 1.16.68 2.32 1 3.48.39 1.35.8 2.7 1.18 4.05s.74 2.83 1.12 4.24c.29 1.12.6 2.24.88 3.36q1.46 5.65 2.72 11.3l-106 61.69c-.83-3.76-1.75-7.52-2.71-11.29-.31-1.18-.61-2.31-.91-3.43Z",
    transform: "translate(-293.73 -428.5)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1385 1570.58c-1.13-1.22-2.23-2.47-3.37-3.67a355.2 355.2 0 0 0-8.1-8.34c-.57-.57-1.12-1.17-1.7-1.74q-4.71-4.65-9.53-9.1l106-61.69q4.82 4.44 9.53 9.1l.17.16c.51.51 1 1.06 1.52 1.57 2.73 2.74 5.44 5.51 8.11 8.35 1.13 1.2 2.23 2.44 3.35 3.66 2.08 2.26 4.15 4.54 6.19 6.87.41.47.84.91 1.25 1.39q3 3.43 5.9 6.95l-106 61.69c-2.35-2.83-4.74-5.6-7.15-8.34-2.01-2.33-4.08-4.6-6.17-6.86Z",
    transform: "translate(-293.73 -428.5)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m1257.98 1397.45 106.01-61.69-62.99-58.98-106 61.69 62.98 58.98z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M1554.11 1883.76a148.24 148.24 0 0 0 .1-34.32l-2.5-23.49 106-61.69 2.49 23.49a148.24 148.24 0 0 1-.1 34.32l-2.61 20.56-106 61.69Z",
    transform: "translate(-293.73 -428.5)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1380.88 1362.81 1400 1371a135.12 135.12 0 0 1 14.93 7.48 165.08 165.08 0 0 1 14.9 9.76l19.14 14-106 61.69-19.14-14a163.23 163.23 0 0 0-14.91-9.77 135 135 0 0 0-14.92-7.48l-19.14-8.14Z",
    transform: "translate(-293.73 -428.5)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m1068.59 1119.23 106.01-61.69-19.35-83.86-106 61.69 19.34 83.86z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m1180.19 1288.37 106.01-61.7 30.93-49.45-106 61.69-30.94 49.46z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m1163.12 1155.66 106-61.69-58.5 1.62-106.01 61.69 58.51-1.62z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1486 1629.06c-1-1.75-1.92-3.52-2.93-5.25-.75-1.3-1.54-2.57-2.31-3.85-1.09-1.8-2.17-3.61-3.29-5.39-1.72-2.71-3.47-5.39-5.28-8l-15.3-22.38 106-61.69 15.31 22.38q2.46 3.6 4.82 7.29l.45.74c1.13 1.78 2.21 3.59 3.29 5.4.67 1.1 1.36 2.18 2 3.29.11.18.2.37.31.55 1 1.73 2 3.5 2.92 5.25.67 1.22 1.38 2.42 2 3.65l.22.44c1 1.82 1.87 3.67 2.79 5.51.62 1.23 1.27 2.44 1.86 3.68l.32.66 11.68 24.42-106 61.69-11.69-24.45c-.69-1.46-1.45-2.89-2.18-4.34-.92-1.84-1.82-3.69-2.78-5.51-.73-1.37-1.5-2.72-2.21-4.09Z",
    transform: "translate(-293.73 -428.5)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m1064.75 1544.41 63.12 13.93a128.09 128.09 0 0 1 15.06-32.84l-30.56-85 11.78-10.86a53.46 53.46 0 0 1 21.16-12.07l15.37-4.64 58.32 69.16a130.5 130.5 0 0 1 36.1 3.65l19.77-61.24 19.14 8.14a135 135 0 0 1 14.92 7.48 163.23 163.23 0 0 1 14.91 9.77l19.14 14 19.34 83.86a391.66 391.66 0 0 1 36 38l58.51-1.62 15.3 22.38a272.09 272.09 0 0 1 21 36.46l11.69 24.42-30.94 49.45a387.6 387.6 0 0 1 14.8 50.11l63 59 2.5 23.49a148.79 148.79 0 0 1-.1 34.32l-2.62 20.56-63.11-14a129 129 0 0 1-15.05 32.88l30.56 85-11.78 10.87a54 54 0 0 1-21.16 12.08l-15.38 4.63-58.31-69.15a131 131 0 0 1-36.11-3.68l-19.76 61.25-19.16-8.13a137.54 137.54 0 0 1-14.91-7.48 164.61 164.61 0 0 1-14.91-9.77l-19.12-14-19.34-83.82a391.06 391.06 0 0 1-36-38l-58.52 1.6-15.29-22.36a272.88 272.88 0 0 1-21-36.46l-11.69-24.44 30.94-49.43a388 388 0 0 1-14.82-50.14l-63-59-2.47-23.5a148.36 148.36 0 0 1 .09-34.33Zm243.09 284.43c50.12 29 90.89 5.69 91.06-52s-40.35-128-90.47-156.95-90.92-5.72-91.08 52 40.34 128 90.49 157",
    transform: "translate(-293.73 -428.5)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M727.36 1353.9a42.25 42.25 0 0 1-6.51 3c-1 .35-1.94.62-2.93.9s-1.87.57-2.82.77a43.64 43.64 0 0 1-5.34.85h-.16a48.34 48.34 0 0 1-5.52.11h-.88a51 51 0 0 1-5.48-.6l-.62-.1a55.74 55.74 0 0 1-5.88-1.4 54 54 0 0 1-5.88-2.16l-.27-.11a58.34 58.34 0 0 1-12.34-7.33l-.19-.14a63.37 63.37 0 0 1-6.07-5.34l-.11-.12a65 65 0 0 1-5.49-6.27l-.14-.18a68.46 68.46 0 0 1-4.81-7.21c-1-1.71-1.89-3.45-2.71-5.2q-1.2-2.6-2.16-5.22a.36.36 0 0 1 0-.11q-1-2.61-1.66-5.24l-.06-.2q-.69-2.57-1.15-5.15v-.28c-.3-1.71-.53-3.41-.68-5.11v-.26c-.15-1.7-.22-3.38-.22-5v-.18c0-1.68.08-3.35.23-5 0-.15 0-.29.05-.44.15-1.55.37-3.08.64-4.59 0-.22.09-.44.14-.66.29-1.47.63-2.93 1-4.36a1.66 1.66 0 0 0 .06-.21c.41-1.41.9-2.78 1.43-4.13.21-.56.46-1.11.69-1.65.36-.82.73-1.63 1.13-2.43.51-1 1.07-2 1.65-3 .34-.57.66-1.15 1-1.7.53-.81 1.11-1.57 1.69-2.34.44-.58.85-1.17 1.31-1.73.64-.77 1.35-1.49 2-2.22.47-.49.91-1 1.4-1.47.82-.78 1.7-1.48 2.58-2.19.45-.36.86-.76 1.32-1.1a42.63 42.63 0 0 1 4.34-2.84l-66.86 38.86a41.47 41.47 0 0 0-4.34 2.83c-.47.35-.88.74-1.32 1.1-.88.71-1.77 1.42-2.58 2.19-.49.47-.93 1-1.4 1.47-.7.73-1.41 1.45-2.06 2.23-.46.56-.87 1.15-1.3 1.73-.58.77-1.17 1.53-1.7 2.34-.1.15-.22.29-.32.45-.25.4-.45.84-.69 1.24-.58 1-1.15 2-1.66 3-.13.26-.29.49-.41.75-.26.54-.47 1.12-.71 1.67s-.48 1.1-.7 1.65c-.08.23-.19.44-.28.66-.41 1.12-.79 2.25-1.12 3.39v.08l-.06.22c-.26.9-.5 1.81-.71 2.73-.12.54-.22 1.08-.33 1.63 0 .22-.09.44-.13.66s-.08.34-.11.51c-.14.85-.27 1.7-.38 2.56-.06.5-.11 1-.16 1.52v.85a59.623 59.623 0 0 0-.19 4.42v2.09c0 .58.05 1.31.09 2 0 .45.07.9.11 1.34V1341.34c.06.62.13 1.24.21 1.87s.16 1.22.26 1.84c.05.35.12.71.18 1.06v.28c0 .1 0 .32.08.48q.17.88.36 1.77c.13.59.27 1.18.41 1.77.09.37.2.75.3 1.13l.05.2.09.34a51.809 51.809 0 0 0 1 3.26c.18.53.33 1 .51 1.47l.06.17v.11l.45 1.19c.18.48.37 1 .57 1.43s.39.91.59 1.37.37.81.55 1.22v.14c.24.51.49 1 .74 1.52s.63 1.24 1 1.86.64 1.15 1 1.72a3.07 3.07 0 0 0 .17.31q1.15 1.95 2.4 3.8c.53.79 1.07 1.56 1.63 2.31l.61.8.13.17.47.62c.37.47.75.94 1.13 1.39s.75.89 1.13 1.33.79.88 1.19 1.31.84.9 1.27 1.34l.3.29.12.12.95.94c.49.46 1 .92 1.47 1.36s1 .91 1.55 1.35 1.06.89 1.61 1.32l.48.36.19.15 1 .75c.56.41 1.12.81 1.69 1.2s1.15.77 1.73 1.14 1.19.74 1.78 1.09l.42.24c.48.28.95.54 1.43.8s1.27.67 1.91 1 1.32.64 2 .93l.42.18.28.12 1.38.59c.73.29 1.46.56 2.19.82s1.53.52 2.3.75a53.483 53.483 0 0 0 5.14 1.27c.24 0 .48.08.73.12l.62.11c.51.08 1 .18 1.53.25 1.05.14 2.09.25 3.14.32h1.69c.59 0 1.18.06 1.77.06 1.25 0 2.5-.07 3.74-.18h.21a44.48 44.48 0 0 0 4.61-.66c.23 0 .45-.13.68-.18 1-.21 1.89-.5 2.83-.77.78-.22 1.57-.37 2.34-.63.2-.07.39-.2.59-.27a43.12 43.12 0 0 0 6.5-3Z",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702 1485.12c-.43.26-.86.52-1.3.77l66.83-38.89 1.31-.77 558.6-334.22-66.87 38.85Z",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1183 861.84-572.38 310.37c-1 .56-2 1.14-3.06 1.72l-66.87 38.86c1-.59 2-1.16 3.06-1.72l572.37-310.37Z",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1658.82 935c.06-2.1.14-4.19.15-6.29 0-3.15 0-6.32-.12-9.49v-1.75c-.09-2.5-.19-5-.35-7.51-.18-2.95-.42-5.9-.7-8.85 0-.28-.06-.56-.09-.84s-.09-.74-.12-1.11c-.23-2.25-.47-4.5-.75-6.75-.36-2.83-.77-5.67-1.21-8.5-.13-.82-.26-1.63-.4-2.45l-172.87 98.52-109.36-60 3-124.12-66.86 38.86-3 124.12 109.36 60 172.87-98.51c1 5.91 1.75 11.81 2.35 17.7 0 .37.09.74.12 1.11.57 5.76.94 11.5 1.15 17.21v1.06c.18 5.52.15 11 0 16.47v2.07c-.19 5.2-.56 10.36-1.05 15.49-.11 1.16-.24 2.31-.36 3.47-.56 5.11-1.23 10.19-2.08 15.21 0 .2-.06.42-.1.62-.89 5.14-2 10.2-3.18 15.21-.44 1.86-1 3.69-1.44 5.53q-1.28 4.89-2.75 9.68c-.8 2.58-1.66 5.12-2.55 7.66-1.2 3.46-2.41 6.92-3.77 10.3-.29.73-.56 1.47-.86 2.19-1.83 4.41-3.82 8.73-5.9 13-.73 1.49-1.5 3-2.26 4.42q-2.5 4.83-5.24 9.5c-.84 1.44-1.67 2.87-2.54 4.28-2.61 4.24-5.31 8.41-8.21 12.44l-.13.17c-2.89 4-6 7.86-9.13 11.64-.9 1.08-1.83 2.14-2.76 3.2q-4 4.53-8.2 8.82c-.79.8-1.55 1.63-2.35 2.41q-5.35 5.25-11.12 10.08c-.87.74-1.78 1.42-2.67 2.14q-4.71 3.83-9.7 7.38c-1.17.83-2.34 1.66-3.53 2.47-4.24 2.89-8.58 5.68-13.1 8.26l66.87-38.86c4.52-2.58 8.85-5.37 13.1-8.26 1.19-.81 2.36-1.64 3.53-2.48q5-3.54 9.69-7.36c.89-.72 1.81-1.41 2.68-2.15q5.76-4.83 11.11-10.07c.81-.79 1.56-1.61 2.35-2.41q4.24-4.3 8.2-8.83c.93-1.06 1.86-2.11 2.76-3.19 3.17-3.78 6.24-7.63 9.12-11.63.05-.07.11-.13.15-.2q3.54-4.9 6.78-10c.5-.79.94-1.62 1.43-2.42.87-1.41 1.69-2.84 2.53-4.27q2.73-4.68 5.24-9.51c.76-1.47 1.53-2.93 2.26-4.42.41-.83.87-1.62 1.27-2.46 1.64-3.45 3.16-7 4.63-10.52.3-.72.57-1.46.87-2.18.73-1.83 1.49-3.65 2.18-5.51.59-1.57 1-3.21 1.59-4.8.88-2.54 1.74-5.08 2.54-7.66.35-1.14.79-2.24 1.12-3.38.61-2.07 1.09-4.19 1.64-6.29.48-1.84 1-3.68 1.44-5.54.18-.76.41-1.5.59-2.26q1.44-6.33 2.56-12.79v-.16c0-.19 0-.39.08-.59q.95-5.49 1.66-11.06c.17-1.39.28-2.8.44-4.19.12-1.15.24-2.3.35-3.45s.27-2.29.36-3.45c.29-3.49.51-7 .66-10.54v-1.5c.01-.78.01-1.48.03-2.13Z",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1235.29 694.11c3.81-1.79 7.65-3.46 11.53-5 .68-.27 1.37-.51 2-.77 2.88-1.09 5.79-2.07 8.71-3 2.19-.72 4.38-1.41 6.59-2.05s4.66-1.29 7-1.88 4.45-1.09 6.69-1.57c2.8-.6 5.62-1.15 8.44-1.63 1.21-.21 2.42-.44 3.64-.62 4.22-.64 8.46-1.18 12.72-1.56h.83c4-.34 8-.54 12-.65l2.87-.07c2.23 0 4.48 0 6.72.09 3.07 0 6.15.13 9.23.31 2.28.13 4.56.33 6.84.53 2.47.22 4.93.46 7.39.76s5 .68 7.54 1.07c2 .32 4.09.64 6.13 1 2.85.53 5.7 1.13 8.54 1.76 1.58.35 3.16.67 4.74 1.06 4.32 1 8.64 2.19 12.93 3.49l.33.11c4.16 1.27 8.3 2.67 12.43 4.17 1.16.42 2.31.87 3.47 1.3q4.91 1.86 9.78 3.93c1 .41 1.93.8 2.9 1.23q6 2.64 11.94 5.61c.79.39 1.56.81 2.34 1.21 4 2 7.93 4.14 11.83 6.4 3.06 1.76 6.09 3.61 9.1 5.51l.93.57c3 1.91 6 3.91 9 6 .89.61 1.77 1.25 2.65 1.88 2.08 1.47 4.16 3 6.21 4.51 1 .76 2 1.54 3.06 2.33 2.56 2 5.12 4 7.63 6l66.86-38.86c-1.63-1.35-3.28-2.67-4.93-4-.89-.7-1.8-1.36-2.7-2l-3-2.33c-.63-.47-1.25-1-1.89-1.44-1.43-1-2.88-2-4.33-3.07-.88-.63-1.75-1.27-2.64-1.88l-.84-.6q-4-2.71-8-5.29l-.13-.07c-.29-.19-.59-.36-.89-.55-2.38-1.5-4.78-3-7.2-4.4-.64-.38-1.28-.76-1.93-1.13q-3.29-1.89-6.6-3.69c-1.73-.94-3.49-1.82-5.24-2.71-.78-.4-1.55-.82-2.33-1.21-.42-.21-.83-.44-1.25-.64q-4.56-2.27-9.18-4.33l-1.52-.64c-1-.43-1.93-.82-2.9-1.23-1.73-.74-3.45-1.5-5.19-2.2-1.52-.61-3.06-1.15-4.58-1.72-1.16-.44-2.31-.89-3.48-1.31-.69-.25-1.37-.53-2.06-.78q-5.18-1.82-10.38-3.39l-.31-.1q-5.71-1.72-11.45-3.16c-.48-.12-1-.2-1.45-.32-1.57-.39-3.16-.7-4.73-1-2-.46-4.09-1-6.13-1.37-.8-.15-1.61-.25-2.41-.4-2-.37-4.09-.69-6.14-1-1.6-.25-3.19-.57-4.78-.79-.92-.12-1.83-.17-2.75-.28-2.46-.3-4.92-.54-7.39-.76-1.47-.13-2.94-.35-4.41-.45-.81-.06-1.62 0-2.43-.08-3.08-.18-6.16-.26-9.24-.31-1.44 0-2.89-.15-4.34-.14h-2.38l-2.87.08c-4 .11-8 .3-11.94.64H1369.37c-4.16.38-8.31.92-12.44 1.54-1.22.19-2.42.41-3.63.62-1.77.3-3.55.55-5.31.9-1 .21-2.09.51-3.13.74-2.25.48-4.48 1-6.7 1.56s-4.67 1.21-7 1.88-4.41 1.33-6.6 2.05c-1.21.39-2.44.7-3.64 1.12-1.69.6-3.37 1.26-5.06 1.9-.68.26-1.37.5-2.06.77q-5.82 2.29-11.52 5-1.22.57-2.43 1.17c-3.9 1.89-7.77 3.87-11.58 6.05l-66.87 38.85c3.81-2.17 7.69-4.15 11.59-6.05Z",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "url(#linear-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1588.29 920.28c16.38 98.56-20.41 195-101.36 241.17-68.12 38.77-151.35 32.81-222.12-8q-2.13-1.23-4.24-2.49L702 1485.12c-40.88 24.47-91.52 21.28-134.49-3.53-25.33-14.63-48-36.78-64.43-65.21-44.24-76.67-25.9-169.21 40.7-205.31l572.34-310.37c-1.22-83.21 35.68-159.83 105.16-199.38 68.13-38.82 151.36-32.88 222.12 8a282.62 282.62 0 0 1 38.6 26.77l-172.87 98.56-3 124.12 109.36 60Zm-927.8 472.48c23.58-13.43 29.87-46.62 14-74.09a64.51 64.51 0 0 0-23.4-23.67c-15.31-8.83-33.31-10.12-48-1.7-23.62 13.41-29.86 46.62-14 74.08a64.41 64.41 0 0 0 23.4 23.69c15.31 8.84 33.31 10.13 48 1.71",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "url(#linear-gradient-12)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.84 1078.89a29 29 0 0 1-15.11 24.22l-403.81 220.58a36.16 36.16 0 0 1-49.26-14.69l-28.83-54.24a29.89 29.89 0 0 1 2.71-32.25 29.78 29.78 0 0 0 3.47 15.68l28.83 54.19a36.17 36.17 0 0 0 49.25 14.77l403.82-220.62a27.92 27.92 0 0 0 8.93-7.64Z",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "url(#linear-gradient-13)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.84 1078.89a27.92 27.92 0 0 1-8.93 7.6l-403.82 220.62a36.17 36.17 0 0 1-49.25-14.77L711 1238.15a29.78 29.78 0 0 1-3.47-15.68 29.37 29.37 0 0 1 9-7.83l395.87-223.19a37.69 37.69 0 0 1 50.82 13.49l34.53 57.61a28.66 28.66 0 0 1 4.09 16.34Z",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "url(#linear-gradient-14)"
    }
  }), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M2052.44 1055s-303 25.3-328.42 67.32 52 146 91.8 229 86.8 150 86.8 150 9.19 6.55 30.87-17.51a195.57 195.57 0 0 0 32.57-50.71l-84.22-218.79 394.19-54S2113.2 1124.8 2052.44 1055Z",
    transform: "translate(-293.73 -428.5)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M1910.78 1501.21s-1.89 36.86-32 72.38-36.16 47.07-10 61.68 55.23 5.48 85-43.21 84.48-76.82 74.62-106.89-64.84-46.71-64.84-46.71-23 40.07-52.78 62.75Z",
    transform: "translate(-293.73 -428.5)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2329.46 1120.57s57.75 87.73-59.34 147.22-250.56 121.7-250.56 121.7 24.71 47.2 20.92 146.74-1.43 175.81-1.43 175.81 10.92 25.36-39.32 25.11-52.25-10.15-52.25-10.15-21.51-232.75-38.84-302.48-35.7-130.54-6-175.49 223.54-134.23 223.54-134.23 123.6 47.51 203.28 5.77Z",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "#45496d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2133.68 630.26s-66.06 56.68-87.79 117.54-34.41 155.53-46.58 171.7-80.86 53.56-80.86 53.56 31.3 6.08 36.52 26.08 3.47 26.95 3.47 26.95 86.08-42.6 99.12-69.55 52.74-97.38 52.74-97.38Z",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "url(#linear-gradient-15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2133.68 630.26s-27.27 26.5-42.38 50.13-16.72 121.25-15.56 128.22-10.32 259.45-10.32 259.45 27.19 51.26 127 67c101.21 16 151.8-7 151.8-7s-33.29-73.13-11.22-154.46 49.71-197.26 27.63-227.92-192.09-131.1-226.95-115.42Z",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "url(#linear-gradient-16)"
    }
  }), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m1469.23 391.84 303.41 173.18v260.59l-303.41-173.18-12.04-254.68 12.04-5.91z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#efefef"
    },
    d: "m1457.19 397.75 303.4 173.18v260.58l-303.4-173.17V397.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#b2b1b1"
    },
    d: "m1760.59 831.51 188.37-125.57-188.37-110.34v235.91z"
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1948.96 705.94v13.12l-188.37 112.45V570.93l12.05-5.91V813.7l176.32-107.76z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#827f7f"
    },
    d: "m1772.64 671.92 74.37 45.56-74.37 43.09v-88.65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2360.68 753.23c-18.95-6.44-52.72 14.64-54.46 78.11s0 150 0 150L2161 1075.65s30.43 2.61 40 23.48 11.3 28.88 11.3 28.88 167.8-93.22 173.88-116.7 13.32-244.9-25.5-258.08Z",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "url(#linear-gradient-17)"
    }
  }), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M2173.74 1078.33s-34 17.06-56.49 31.79-32.92 48.51-32.05 52 27.64 23.39 35.91 23.39 29.93-31.19 47.26-41.58 37.94-32.69 37.94-32.69 2.26-26.58-32.57-32.91ZM2100.77 552.36s4.11 50.69 10 67.35 32.48 62.78 44.07 66.92 25.24-1.61 25.24-1.61l.43 13.84s3.11 22 42.22 18 59.57-22.31 59.57-22.31-19.92-39.81-23.38-70.68-21.47-105.8-56.2-112.27-101.95 40.76-101.95 40.76Z",
    transform: "translate(-293.73 -428.5)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M2132.62 561.75c39.76-2 57.35-16.54 57.35-16.54s-7.26 18.51 5.48 26.31 14.69 48.46 20.4 47.66-1.73-36.51 15.44-38.79 13.5 8.3 13.87 22.6S2243 627 2257 628.62s37.32-40.47 31.49-77.82-31.75-45.67-31.75-45.67 2.73-49.59-65.19-36.73-90.55 32.6-111.46 23.25-29.64 74.17 52.53 70.1Z",
    transform: "translate(-293.73 -428.5)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2178.83 684.69s24.05-4.86 32.42-19.51 11-18.68 11-18.68a122.06 122.06 0 0 1-10.11 34.88c-8.52 18.66 2.68 36 2.68 36s-29.12 3.86-32.85-14-3.14-18.69-3.14-18.69Z",
    transform: "translate(-293.73 -428.5)",
    style: {
      fill: "#eaa2a2"
    }
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M2038.53 1724.09s19.59 38.39 11.68 48.74-83.12 51.12-102.73 74.86-58 21.3-78.65 4.26-19.24-31.65 18.07-61.47a336.79 336.79 0 0 0 60.58-63.48s51.94 23.12 91.05-2.91Z",
    transform: "translate(-293.73 -428.5)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.b772d1a98756ce174bd2935ea905fab8.svg";
export { ForwardRef as ReactComponent };